/** Session key for post-Auth0 redirect (set from appState in index.js onRedirectCallback). */
const STORAGE_KEY = 'transforma_return_to';

/**
 * Paths allowed after login (same-origin path only). Extend when adding new post-login entry routes.
 */
export function isAllowedReturnPath(p) {
  if (typeof p !== 'string' || !p.startsWith('/') || p.startsWith('//')) return false;
  if (p.includes('..')) return false;
  if (p === '/home' || p === '/onboarding' || p === '/admin' || p === '/admin/users' || p === '/workspace') return true;
  if (p.startsWith('/programme/')) return true;
  if (p.startsWith('/project/')) return true;
  return false;
}

export function setReturnTo(path) {
  if (!path || !isAllowedReturnPath(path)) return;
  try {
    sessionStorage.setItem(STORAGE_KEY, path);
  } catch {
    /* ignore */
  }
}

/** Read validated path without removing (safe if effect runs twice, e.g. React StrictMode). */
export function peekReturnTo() {
  try {
    const v = sessionStorage.getItem(STORAGE_KEY);
    return v && isAllowedReturnPath(v) ? v : null;
  } catch {
    return null;
  }
}

export function consumeReturnTo() {
  try {
    const v = sessionStorage.getItem(STORAGE_KEY);
    sessionStorage.removeItem(STORAGE_KEY);
    return v && isAllowedReturnPath(v) ? v : null;
  } catch {
    return null;
  }
}

export function clearReturnTo() {
  try {
    sessionStorage.removeItem(STORAGE_KEY);
  } catch {
    /* ignore */
  }
}
